import React from 'react';
import { graphql } from 'gatsby';
import { Page, Contact } from '@mq/gatsby-components';

import IndexLayout from '../layouts';
import { isQA, getMostRecentDraft } from '../utils/misc';

import {
  ContactPage_craft_categories as CategoryI,
  ContactPage_craft_entry_Craft_contact_contact_Entry as EntryI,
} from '@mq/generated-types/dist/ContactPage';

interface CraftData {
  data: {
    craft: {
      categories: CategoryI[];
      drafts: [EntryI];
      entry: EntryI;
    };
  };
}

const ContactPage: React.FC<CraftData> = ({ data }) => {
  let { categories, drafts, entry } = data.craft;

  if (isQA && drafts.length) {
    entry = getMostRecentDraft(drafts);
  }

  return (
    <IndexLayout>
      <Page>
        <Contact
          contactList={entry.supportPanellRow}
          products={categories.map((category) => category.title)}
        />
      </Page>
    </IndexLayout>
  );
};
export default ContactPage;

export const query = graphql`
  query ContactPage {
    craft {
      categories(group: "products") {
        title
      }
      drafts: entries(type: "contact", drafts: true) {
        id
        title
        ...ContactFragment
      }
      entry(type: "contact") {
        id
        title
        ...ContactFragment
      }
    }
  }
`;
